var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2380:1772)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#8FBBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 23.2218C19.5406 23.2218 23.2218 19.5406 23.2218 14.9996C23.2218 10.4586 19.5406 6.77734 14.9996 6.77734C10.4586 6.77734 6.77734 10.4586 6.77734 14.9996C6.77734 19.5406 10.4586 23.2218 14.9996 23.2218Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6623 17.4443C17.809 18.5288 16.4846 19.2221 15.0001 19.2221C13.5157 19.2221 12.1912 18.5288 11.3379 17.4443",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3338 13.8892C12.9474 13.8892 13.4449 13.3918 13.4449 12.7781C13.4449 12.1645 12.9474 11.667 12.3338 11.667C11.7201 11.667 11.2227 12.1645 11.2227 12.7781C11.2227 13.3918 11.7201 13.8892 12.3338 13.8892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6668 13.8892C18.2804 13.8892 18.7779 13.3918 18.7779 12.7781C18.7779 12.1645 18.2804 11.667 17.6668 11.667C17.0531 11.667 16.5557 12.1645 16.5557 12.7781C16.5557 13.3918 17.0531 13.8892 17.6668 13.8892Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2380:1772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyGreenIcon);
export default __webpack_public_path__ + "static/media/happy-green-icon.b083f80eb253fefbab4b081602747307.svg";
export { ForwardRef as ReactComponent };